import React from "react";
import { TodoContext } from "../TodoContext";
import { TodoHeader } from "../TodoHeader";

function TodoLayout(props) {
  const { darkMode, toggleDarkMode } = React.useContext(TodoContext);

  return (
    <main
      className={`${
        darkMode ? "dark bg-gray-900 text-white" : "bg-gray-100"
      } h-screen overflow-auto`}
    >
      <TodoHeader onDarkMode={() => toggleDarkMode()} />
      <div className="flex justify-center mt-20 p-6">
        <div className="w-full md:w-1/2">{props.children}</div>
      </div>
    </main>
  );
}

export { TodoLayout };
